import React, { useState } from 'react';
import axiosInstance from '../../utils/axios';
import './ForgotPasswordPage.css';

function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');
        setMessage('');
        setIsLoading(true);

        try {
            await axiosInstance.post('/api/public/forgot-password', { email });
            setMessage('Parooli taastamise link saadeti Teie meilile.');
        } catch (error) {
            const errorMsg = error.response?.data?.message || error.response?.data || "Palun proovi uuesti";
            setErrorMessage(errorMsg);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="forgot-password-container">
            <div className="forgot-password-box">
                <h2>Unustasid parooli?</h2>
                <p className="description">Sisesta oma emaili aadress ja me saadame parooli lähtestamiseks lingi.</p>
                <form onSubmit={handleSubmit} className="forgot-password-form">
                    <div className="form-group">
                        <label>Email</label>
                        <input 
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Sisesta oma email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            autoComplete="email"
                        />
                    </div>
                    <button type="submit" disabled={isLoading}>
                        {isLoading ? 'Saadan...' : 'Saada link emailile'}
                    </button>
                    {message && (
                        <p className="success-message">
                            {message}
                        </p>
                    )}
                    {errorMessage && (
                        <p className="error-message">
                            {errorMessage}
                        </p>
                    )}
                    <div className="back-to-login-link">
                        <a href="/login">
                        Tagasi login lehele
                        </a>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ForgotPasswordPage;

